import React from 'react';
import { useStore } from '@store';
import { observer } from 'mobx-react-lite';
import { Modal } from '@components';

const TransFlagModal = ({ visibleHandler, closeModal, msg }) => {
    return (
        <Modal show={visibleHandler} onHide={closeModal} title={'訊息提示'}>
            <form
                onSubmit={async e => {
                    e.preventDefault();
                    closeModal();
                }}
            >
                <div className="border-0">
                    <div className="icon_fast mx-auto "></div>
                    <div className="icon_info mx-auto mb-3"></div>
                    <h3 className=" title fw-bolder text-center mt-3 lh-base">
                        {msg}
                        {/* 作業中，請稍後再申請！ */}
                    </h3>
                    <div className="btn_box d-flex flex-column-reverse flex-sm-row justify-content-center">
                        <button
                            className="btn_check btn rounded-pill text-white"
                            type="submit"
                        >
                            確認
                        </button>
                    </div>
                </div>
            </form>
        </Modal>
    );
};

export default observer(TransFlagModal);
